import { useTranslation } from "react-i18next";

interface TitleProps {
    noColours?: boolean;
}

export const Title = ({ noColours = false }: TitleProps) => {
    const { t } = useTranslation();

    return (
        <>
            <span className={noColours ? "text-white" : "text-brandGreen"}>{t('main.title.green')}</span>
            <span className={noColours ? "text-white" : "text-brandBlue"}>{t('main.title.blue')}</span>
            <span> {t('main.title.default')}</span>
        </>
    )
}